(function () {
        var scroller = document.querySelector('[data-scroll]');
        var prevBtn = document.querySelector('[data-prev]');
        var nextBtn = document.querySelector('[data-next]');
        if (!scroller) return;

        function getStep() {
            var competitors = scroller.querySelectorAll('thead th:nth-child(n+3)');
            if (!competitors.length) return 0;
            return competitors[0].getBoundingClientRect().width;
        }

        function updateArrows() {
            if (!prevBtn || !nextBtn) return;
            var max = scroller.scrollWidth - scroller.clientWidth;
            prevBtn.disabled = scroller.scrollLeft <= 2;
            nextBtn.disabled = scroller.scrollLeft >= max - 1;
        }

        if (prevBtn) prevBtn.addEventListener('click', function () {
            scroller.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        if (nextBtn) nextBtn.addEventListener('click', function () {
            scroller.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        scroller.addEventListener('scroll', function () {
            window.requestAnimationFrame(updateArrows);
        });

        window.addEventListener('resize', updateArrows);
        updateArrows();
    })();

    